import sha1 from 'sha1'
import qs from 'qs'
const sign = (params, noSignAttr = []) => {
  const secret = window.$config.axios.secret
  delete params.sign
  var objStr = qs.stringify(params, { arrayFormat: 'indices', encode: false, allowDots: true })
  var objVal = objStr.split('&')
  var realObj = {}
  objVal.forEach(item => {
    if (item.split('=')[0] == 'scene') {
      realObj.scene = params.scene
    } else {
      realObj[item.split('=')[0]] = item.split('=')[1]
    }
  })

  const keys = Object.keys(realObj).sort()
  var str = []
  var obj = null
  for (const key in realObj) {
    obj = realObj[key]
    if (obj === null) {
      obj = ''
    } else if (typeof obj === 'object') {
      obj = JSON.stringify(obj)
    }
    realObj[key] = obj
  }
  keys.forEach(e => {
    !noSignAttr.includes(e) && str.push(e + realObj[e])
  })
  realObj.sign = sha1(secret + str.join('') + secret).toUpperCase()
  return realObj
}
export default sign